import { render, staticRenderFns } from "./JoppdNumber.vue?vue&type=template&id=57ad24f9&scoped=true"
import script from "./JoppdNumber.vue?vue&type=script&lang=js"
export * from "./JoppdNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad24f9",
  null
  
)

export default component.exports